<ion-header>
    <ion-toolbar>
        <ion-title>
            <!-- Test Page -->
        </ion-title>
    </ion-toolbar>

</ion-header>

<ion-content>
    <div class="cnvs">
        <canvas id="myCanvas">
            Your browser does not support the canvas element.
        </canvas>
    </div>
    <!-- <trophy #trophy id="trophy" style="height: 100%; width: 100%;" [result]="result" offset="100"></trophy> -->
</ion-content>